import { Component, Input, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbDateParserFormatter, NgbDatepickerModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonService } from '../../../Model/Common/common.service';
import { CompensatoryOffService } from '../../../Model/CompensatoryOff/compensatory-off.service';
import { SessionService } from '../../../Util/Session/session.service';
import { CommonModule, JsonPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterOutlet, RouterModule } from '@angular/router';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';

@Component({
  selector: 'app-compensatory-off-consume-form-popup',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, NgbDatepickerModule, FormsModule, JsonPipe, DataTablesModule, NgbDropdownModule, LoaderComponent],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './compensatory-off-consume-form-popup.component.html',
  styleUrl: './compensatory-off-consume-form-popup.component.scss'
})
export class CompensatoryOffConsumeFormPopupComponent {
  isDisabled: boolean = false;
  @Input() LeaveFromDate: string = '';
  @Input() LeaveToDate: string = '';
  @Input() EmpMasterID: any = '';

  CompoffHistory = [];
  user = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private activeModal: NgbActiveModal,
    private compensatoryOff: CompensatoryOffService,
    private session: SessionService,
    protected common: CommonService,
  ) {
    this.user = this.session.GetUserDetails();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESS_EmployeeCompOffConsumeLoad();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESS_EmployeeCompOffConsumeLoad() {
    this.isDisabled = true;
    console.log(this.EmpMasterID);
    this.compensatoryOff.ESS_EmployeeCompOffConsumeLoad({ 'SelectType': 2, 'EmpMasterID': this.EmpMasterID, 'FromDate': '', 'ToDate': this.LeaveToDate}).subscribe({
      next: (response) => {
        if(response.Table.length > 0){
          this.CompoffHistory = response.Table;
        }else{
          this.CompoffHistory = [];
        }
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  close() {
    this.activeModal.close();
  }
}
